"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("../utils/prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SearchFilterButton = function SearchFilterButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.settings.Filters.length > 0 && /*#__PURE__*/_react["default"].createElement("button", {
    className: "search-filter-button",
    onClick: function onClick(e) {
      props.onOpenFilterList(e);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-icon"
  }), props.settings.dictionary.filterListButton));
};

var _default = SearchFilterButton;
exports["default"] = _default;
SearchFilterButton.propTypes = {
  onOpenFilterList: _propTypes["default"].func,
  settings: _propTypes["default"].settings
};
SearchFilterButton.defaultProps = {
  onOpenFilterList: _propTypes["default"].defaultOnOpenFilterList,
  settings: _propTypes["default"].defaultSettings
};